import deepEqual from 'react-fast-compare';

export function includesObject<T>(array: T[], object: T): boolean {
  return array.some((item) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    Object.keys(item).every((key) => deepEqual(item[key], object[key])),
  );
}
